import { addDays, differenceInDays, format } from 'date-fns';

/**
 * 체크인/아웃 날짜 텍스트 생성
 * 형식: MM.DD~MM.DD, n박
 */
export const createCheckInOutText = (checkInDate: string, checkOutDate: string) => {
  const today = new Date();
  const checkIn = checkInDate || format(today, 'yyyy-MM-dd');
  const checkOut = checkOutDate || format(addDays(today, 1), 'yyyy-MM-dd');
  const period = differenceInDays(checkOut, checkIn);

  return `${format(checkIn, 'MM.dd')}~${format(checkOut, 'MM.dd')}${period >= 1 ? `, ${period}박` : ''}`;
};
/**
 * 인원 수 텍스트 생성
 * 형식: 성인 n, 아동 m
 */
export const createCapacityText = (capacityAdult: number, capacityChild: number) => {
  const adults = capacityAdult || 2;
  const children = capacityChild || 0;
  const childText = children > 0 ? `, 아동 ${children}` : '';
  return `성인 ${adults}${childText}`;
};
/**
 * 체크인/아웃 및 인원 수 통합 텍스트 생성
 * 형식: MM.DD~MM.DD · n명
 */
export const createCheckInOutCapacityText = (
  checkInDate: string,
  checkOutDate: string,
  capacityAdult: number,
  capacityChild: number,
) => {
  const today = new Date();
  const checkIn = checkInDate || format(today, 'yyyy-MM-dd');
  const checkOut = checkOutDate || format(addDays(today, 1), 'yyyy-MM-dd');
  const checkInOutText = `${format(checkIn, 'MM.dd')}~${format(checkOut, 'MM.dd')}`;

  const adults = capacityAdult || 2;
  const children = capacityChild || 0;
  const capacityText = `${adults + children}명`;

  return `${checkInOutText} · ${capacityText}`;
};
/**
 * 체크인/아웃, 객실 및 인원 수 해외숙소 텍스트 생성
 * 형식: MM.DD~MM.DD · n명
 */
export const createGlobalCheckInOutCapacityText = (
  checkInDate: string,
  checkOutDate: string,
  capacityRooms: { adult: number; child: number[] }[],
) => {
  const today = new Date();
  const checkIn = checkInDate || format(today, 'yyyy-MM-dd');
  const checkOut = checkOutDate || format(addDays(today, 1), 'yyyy-MM-dd');
  const checkInOutText = `${format(checkIn, 'MM.dd')}~${format(checkOut, 'MM.dd')}`;

  const adults = capacityRooms.reduce((acc, room) => acc + (room.adult || 0), 0) || 2;
  const children = capacityRooms.reduce((acc, room) => acc + (room.child?.length || 0), 0);
  const capacityText = `${adults + children}명`;
  const capacityRoomsText = `객실 ${capacityRooms.length || 1}`;

  return `${checkInOutText} · ${capacityRoomsText}, ${capacityText}`;
};
/**
 * 글로벌 필터 국내숙소 가격 범위 텍스트 생성
 * 형식: 성인 n, 아동 n, n박 기준
 */
export const createGlobalFilterPriceRangeText = ({
  checkInDate,
  checkOutDate,
  capacityAdult = 2,
  capacityChild = 0,
}: {
  checkInDate: string;
  checkOutDate: string;
  capacityAdult: number;
  capacityChild: number;
}) => {
  const today = new Date();
  const checkIn = checkInDate || format(today, 'yyyy-MM-dd');
  const checkOut = checkOutDate || format(addDays(today, 1), 'yyyy-MM-dd');
  const period = differenceInDays(checkOut, checkIn);

  const adults = capacityAdult || 2;
  const children = capacityChild || 0;

  return `성인 ${adults}, 아동 ${children}, ${period}박 기준`;
};
/**
 * 글로벌 필터 해외숙소 가격 범위 텍스트 생성
 * 형식: 성인 n, 아동 n, n박 기준
 */
export const createGlobalFilterGlobalPriceRangeText = ({
  checkInDate,
  checkOutDate,
  capacityRooms = [],
}: {
  checkInDate: string;
  checkOutDate: string;
  capacityRooms: { adult: number; child: number[] }[];
}) => {
  const today = new Date();
  const checkIn = checkInDate || format(today, 'yyyy-MM-dd');
  const checkOut = checkOutDate || format(addDays(today, 1), 'yyyy-MM-dd');
  const period = differenceInDays(checkOut, checkIn);

  const adults = capacityRooms.reduce((acc, room) => acc + (room.adult || 0), 0) || 2;
  const children = capacityRooms.reduce((acc, room) => acc + (room.child?.length || 0), 0);

  return `성인 ${adults}, 아동 ${children}, ${period}박 기준`;
};
